/*=========================================================================================
  File Name: moduleUnit.js
  Description: Units Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from "./modulePlacesState";
import mutations from "./modulePlacesMutations";
import actions from "./modulePlacesActions";
import getters from "./modulePlacesGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
